import React, {useEffect, useImperativeHandle} from "react";
import {Space, Form} from "antd";
import {catalogService} from "api";
import {
  convertIosStringToDate,
  formatDateToString,
  toArray,
} from "helper/common";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import Notification from "components/common/notification/notification";
import {setStatusTraThuoc} from "redux/reducer/nurseOut";
import fields from "./config";
import {searchEmployeeAPI} from "redux/reducer/employee";
type Props = {
  detailPhieu: any;
  children: any;
};
const PatientInfo = React.forwardRef<any>((props: Props, ref) => {
  const dispatch = useAppDispatch();
  const detailPhieu = useAppSelector(state => state.nurseOut.detailPhieu);
  const statusTraThuoc = useAppSelector(state => state.nurseOut.statusTraThuoc);
  const [form] = Form.useForm();
  // useEffect(() => {
  //   dispatch(searchEmployeeAPI({page: 1, limit: 40, idPhongBan: 27}));
  // }, []);
  // const employeesList = useAppSelector(
  //   state => state.employeesReducer.employeesList
  // );
  // // fields.find(e => e.name == "tenDieuDuong").options = toArray(
  // //   employeesList
  // // ).map(e => ({
  // //   value: e?.hoTen,
  // //   label: e?.hoTen,
  // // }));
  //set lai value
  useEffect(() => {
    form.setFieldsValue({
      ...detailPhieu,
      ngayTao: detailPhieu?.ngayTao ? moment(detailPhieu.ngayTao) : "",
      phong: detailPhieu?.phong,
      tuoi:
        moment().year() - convertIosStringToDate(detailPhieu?.ngaySinh)?.year(),
      tenDieuDuong:
        detailPhieu?.tenDieuDuong ?? localStorage.getItem("fullName"),
    });
    dispatch(setStatusTraThuoc(detailPhieu?.traThuoc));
  }, [detailPhieu]);
  useEffect(() => {
    form.setFieldValue("traThuoc", statusTraThuoc);
  }, [statusTraThuoc]);
  // const getListLoaiKCB = async () => {
  //   try {
  //     const res = await catalogService.getListLoaiKCB();
  //     fields.find(e => e.name == "loaiKCB").options = await res.map(e => {
  //       return {value: e.id, label: e.tenLoaiKCB};
  //     });
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi khi lấy danh sách loại khám chữa bệnh");
  //     // fields[8].options = [];
  //   }
  // };

  // const getListTrangThaiPhieu = async () => {
  //   try {
  //     const res = await catalogService.getListTrangThaiPhieu();

  //     fields.find(e => e.name == "trangThai").options = await res.map(e => {
  //       return {value: e.id, label: e.tenTTPhieuKham};
  //     });
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi khi lấy danh sách trạng thái tra thuốc");
  //   }
  // };
  // const field = fields();
  // const getListTrangThaiTraThuoc = async () => {
  //   try {
  //     const res = await catalogService.getListTrangThaiTraThuoc();

  //     field.find((e) => e.name == "traThuoc").options = await res.map((e) => {
  //       return { value: e.id, label: e.tenTTTraThuoc };
  //     });
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi khi lấy danh sách trạng thái tra thuốc");
  //   }
  // };
  // const getListPhong = async () => {
  //   try {
  //     const res = await catalogService.getListPhong();
  //     fields.find(e => e.name == "phong").options = res.map(e1 => {
  //       return {
  //         value: e1.id,
  //         label: `${e1?.tenPhong} (${e1?.soBenhNhan})`,
  //       };
  //     });
  //     console.log(res);
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi khi lấy danh sách phòng");
  //   }
  // };
  const formatFormValue = () => {
    const rawValues = form.getFieldsValue();

    const formatValues = {
      ...rawValues,
      ngaySinh: formatDateToString(rawValues.ngaySinh, null),
    };
    return formatValues;
  };

  // const handleClickButton = () => {
  //   message.info("Chưa có thông tin phiếu");
  // };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
    validateFields: async () => {
      await form.validateFields();
    },
  }));
  return (
    <div className="patient-info">
      <Space direction="vertical" style={{width: "100%"}}>
        <Form labelAlign="left" form={form}>
          {fields && <PatientInfoCommon data={detailPhieu} fields={fields} />}
        </Form>
      </Space>
    </div>
  );
});
export default PatientInfo;
